// extracted by mini-css-extract-plugin
export var formContainer = "_l3-0";
export var message = "_l3-1";